import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import ReactDom from "react-dom";
import ComboHeader from "../ComboHeader/ComboHeader";
import { IconButton, Tooltip, styled } from "@mui/material";
import CircleLoader from "../Loaders/CircleLoader";
import DownloadIcon from "../../assets/icons/download-icon.svg"

const ButtonWrapper = styled("div")({
	button: {
		alignItems: "center",
		backgroundColor: "#fff",
		borderRadius: "6px",
		display: "flex",
		padding: "8px 12px",
		span: {
			color: "#0DA9D5",
			fontSize: "12px",
			fontWeight: "600",
			letterSpacing: "0.15em",
			marginRight: "5px",
			whiteSpace: "nowrap",
		},
	},
});

const LoaderWrapper = styled("div")({
	"& img": {
		maxWidth: "18px",
		maxHeight: "16px",
	},
});

function Card({
	children,
	style,
	className,
	expandable,
	absoluteExpandButton,
	header,
	app,
	cardContentStyle,
	exportTable,
	exportTableId,
	exportContainer,
}) {
	const [isExpanded, setExpand] = useState(false);
	const mounted = useRef();
	const [loadingExcel, setLoadingExcel] = useState(false);

	useEffect(() => {
		mounted.current = true;

		return () => {
			mounted.current = false;
		};
	}, []);

	const handleExpand = () => {
		if (mounted.current) {
			setExpand(!isExpanded);
		}
	};

	const exportToXLS = async (objectId) => {
		console.log("Iniciando exportToXLS com objectId:", objectId);
		setLoadingExcel(false);
		let id = objectId;
	
		if (exportContainer) {
			console.log("exportContainer está definido, tentando obter visualização...");
			await app.visualization
				.get(objectId)
				.then((vis) => {
					id = vis.model.items.activeId;
					console.log("Novo ID obtido da visualização:", id);
				})
				.catch((error) => {
					console.error("Erro ao obter visualização:", error);
					setLoadingExcel(false);
				});
		}
	
		if (app && id) {
			setLoadingExcel(true);
			console.log("Chamando app.visualization.get com id:", id);
			await app.visualization
				.get(id)
				.then((vis) => {
					console.log("Visualização obtida, exportando dados...");
					vis.table
						.exportData({ format: "OOXML", state: "A" })
						.then((link) => {
							setLoadingExcel(false);
							console.log("Link exportado:", link);
	
							try {
								// Verifica se a URL é relativa
								let newUrl;
								if (link.startsWith("/webticket-api-qlik/")) {
									// Se for relativa, concatena com o domínio correto
									newUrl = `https://qsense.mtrix.com.br${link}`;
								} else {
									// Caso contrário, usa o link como está
									newUrl = link;
								}
	
								console.log("Novo link formatado:", newUrl);
	
								// Abre a URL formatada teste 01
								window.open(newUrl);
							} catch (error) {
								console.error("Erro ao modificar a URL:", error);
							}
						})
						.catch((error) => {
							console.error("Erro ao exportar dados:", error);
							setLoadingExcel(false);
						});
				})
				.catch((error) => {
					console.error("Erro ao obter visualização para exportação:", error);
					setLoadingExcel(false);
				});
		} else {
			console.warn("Exportação cancelada: app ou id não definido.");
		}
	};

	const Content = () => (
		<div
			className={
				isExpanded ? "expandedCardContainer" : `${className} card`
			}
			style={style}
		>
			<div
				className={
					isExpanded ? "expandedCardContent" : "cardContentArea"
				}
				style={cardContentStyle}
			>
				<div
					className="cardHeader"
					style={{
						justifyContent: header ? "space-between" : "flex-end",
					}}
				>
					{header && (
						<ComboHeader
							app={app}
							reference={{
								title: {
									id: header.titleId,
									hard: header.hardTitle,
								},
								subtitle: {
									id: header.subtitle,
									hard: header.hardSubtitle,
								},
							}}
							tooltip={header.tooltip}
							legends={header.legends}
							radio={header.radio}
							classStyle={header.classStyle}
							scale={header.scale}
						/>
					)}
					{expandable && (
						<div
							className={
								absoluteExpandButton
									? "primaryButton expandButton absolute"
									: "primaryButton expandButton"
							}
							style={{
								flexDirection: "row",
								justifyContent: "end",
							}}
						>
							<ButtonWrapper>
								<Tooltip
									title={isExpanded ? "Reduzir" : "Ampliar"}
								>
									<IconButton
										type="button"
										onClick={() => handleExpand()}
									>
										<i className="fal fa-expand" />
									</IconButton>
								</Tooltip>
							</ButtonWrapper>
						</div>
					)}
					{exportTable && (
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "flex-start",
								padding: "0px 4px 12px",
							}}
						>
							<ButtonWrapper>
								<Tooltip title="Exportar para Excel">
									<IconButton
										type="button"
										onClick={() =>
											exportToXLS(exportTableId)
										}
                    >
                      <span>Exportar </span>
										{!loadingExcel ? (
                      <img src={DownloadIcon} alt="icon-downloaf" />
                      ) : (
                        <LoaderWrapper>
												<CircleLoader />
											</LoaderWrapper>
										)}
									</IconButton>
								</Tooltip>
							</ButtonWrapper>
						</div>
					)}
				</div>
				{children}
			</div>
		</div>
	);
	return isExpanded ? (
		ReactDom.createPortal(
			<Content />,
			document.getElementById("expandedWrapper")
		)
	) : (
		<Content />
	);
}
Card.defaultProps = {
	children: null,
	style: null,
	className: "",
	expandable: false,
	header: null,
	app: null,
	cardContentStyle: {},
	absoluteExpandButton: false,
	exportTableId: "",
	exportTable: false,
	exportContainer: false,
};
Card.propTypes = {
	children: PropTypes.any,
	style: PropTypes.object,
	expandable: PropTypes.bool,
	className: PropTypes.string,
	header: PropTypes.object,
	app: PropTypes.object,
	absoluteExpandButton: PropTypes.bool,
	cardContentStyle: PropTypes.object,
	exportTableId: PropTypes.string,
	exportTable: PropTypes.bool,
	exportContainer: PropTypes.bool,
};
export default Card;
